export var truncateWords = function truncateWords(str, options) {
  if (!str) {
    return '';
  }

  var _a = options.max,
      max = _a === void 0 ? 10 : _a,
      _b = options.ellipsis,
      ellipsis = _b === void 0 ? '...' : _b,
      _c = options.glue,
      glue = _c === void 0 ? ' ' : _c;
  var array = str.trim().split(' ');
  var suffix = ellipsis && array.length > max ? '...' : '';
  return "" + array.slice(0, max).join(glue) + suffix;
};